import { render } from "./videoMod.vue?vue&type=template&id=32079bdb&scoped=true"
import script from "./videoMod.vue?vue&type=script&lang=js"
export * from "./videoMod.vue?vue&type=script&lang=js"

import "./videoMod.vue?vue&type=style&index=0&id=32079bdb&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32079bdb"]])

export default __exports__